export { default as GenericCard } from "./GenericCard";
